import WidgetView from 'views/dashboard/widgetView'
import template from 'text-loader!templates/dashboard/widget/swissLogoWidget.html'

WidgetView.SwissLogoWidget = WidgetView.extend({
  template: template
});

export default WidgetView.SwissLogoWidget;

